import { createFileRoute, redirect } from '@tanstack/react-router'
import APIDocsPage from '../pages/APIDocsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/api-docs' as any)({
    component: APIDocsPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
